
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|3159|7403|8157)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
